// New-project modal — a thin wrapper around the shared ProjectForm (create mode).

import type { Project } from "../api/types";
import { ProjectForm } from "./ProjectForm";

interface Props {
  onClose: () => void;
  onCreated: (project: Project) => void;
}

export function CreateProjectModal({ onClose, onCreated }: Props) {
  return <ProjectForm mode="create" onClose={onClose} onDone={onCreated} />;
}
